<template>
    <span class="label-annotated">
        <span class="label-annotated-body"><slot></slot></span>
        <span class="label-annotated-facet" v-if="facet"
        >{{facet}}</span>
        <span class="label-annotated-note" v-if="note"
        >{{note}}</span>
    </span>
</template>
<script>
export default {
    name: 'LabelAnnotated',
    props: {
        facet: { 
            type: [String, Number],
            required: false,
        },
        note: { 
            type: [String, Number],
            required: false,
        },
        bold: {
            type: Boolean,
            default: false,
            required: false,
        },
    },
}
</script>
<style>
.label-annotated {
    flex-grow: 1; /* As a flex child with a parent */
    display: flex;
    flex-direction: row;
    justify-content: space-between;
}

.label-annotated-facet {
    background-color: #6663;
    margin: 0 -4px;
    padding: 0px 4px;
    font-size: 12px;
    border-radius: 4px;
}
.label-annotated-facet::before,
.label-annotated-note::before {
    /* content: "("; */
    content: "";
}
.label-annotated-facet::after,
.label-annotated-note::after {
    /* content: ")"; */
    content: "";
}
.label-annotated-note {
    color: #bbb;
}
/*
.label-annotated-bold {
    font-weight: bold;
}
*/
</style>